import {includes} from "lodash";

export function accountCheckRun($auth, $rootScope, $state, $location) {

	"ngInject";

	let is = (event, toState) => {
		if (
			!includes([
				"auth.signin",
				"auth.signup",
				"auth.password",
				"auth.acceptInvite",
				"auth.resetPassword",
				"auth.twoFactor",
				"auth.twoFactorSuccess"
			], toState.name) &&
			!$auth.isAuthenticated()
		) {
            sessionStorage.clear();
            localStorage.clear();
            $state.go("auth.signin");
            return event.preventDefault();
		}
	};

	$rootScope.$on("$stateChangeStart", (event, toState) => is(event, toState));

	if(
		!$auth.isAuthenticated() &&
		$location.absUrl().indexOf("password") === -1 &&
		$location.absUrl().indexOf("email") === -1 &&
        $location.absUrl().indexOf("accept-invite") === -1 &&
		$location.absUrl().indexOf("password-set") === -1
	){
		$state.go("auth.signin");
		return false;
	}

}



// WEBPACK FOOTER //
// ./sources/bootstrap/account-check.js